import * as profile from '@/api/profile'

// 获取公司概述 简介的banner图
export function fetchBanner() {

	const param = {
		client: 0
	}

	return new Promise(function(resolve, reject){
		profile.getBanner(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.imgUrl = result.data

				resolve(responseBody)
			})
	})
}

// 获取公司概述 简介的内容
export function fetchAbout() {

	const param = {
		type: 0,
		language: 'zh'
	}

	return new Promise(function(resolve, reject){
		profile.getAbout(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.content = result.data.content

				resolve(responseBody)
			})
	})
}

// 获取公司概述 文化
export function fetchCulture() {

	const param = {
		type: 1,
		language: 'zh'
	}

	return new Promise(function(resolve, reject){
		profile.getAbout(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.content = result.data.content

				resolve(responseBody)
			})
	})
}

// 获取公司概述 新闻
export function fetchNews(current) {

	const param = {
		current_page: current,
		type: 0
	}

	return new Promise(function(resolve, reject){
		profile.getNews(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.list = result.data

				resolve(responseBody)
			})
	})
}

// 获取公司概述 新闻详情
export function fetchNewsDetails(id) {

	const param = {
		id: id
	}

	return new Promise(function(resolve, reject){
		profile.getNewsDetails(param)
			.then(function(result) {

				let responseBody = new Array()
				responseBody.content = result.data

				resolve(responseBody)
			})
	})
}


// 获取公司概述 党建
export function fetchTrends(current) {

	const param = {
		current_page: current,
		type: 1
	}

	return new Promise(function(resolve, reject){
		profile.getTrends(param)
			.then(function(result) {

				let responseBody = new Array()
				responseBody.list = result.data

				resolve(responseBody)
			})
	})
}